import React from 'react';
import Icon from 'components/AppIcon';

const CATEGORY_ICONS = {
  Groceries: 'ShoppingCart',
  Rent: 'Home',
  Transportation: 'Car',
  Entertainment: 'Tv',
  Shopping: 'ShoppingBag',
  Dining: 'UtensilsCrossed',
  Healthcare: 'Heart',
  Other: 'MoreHorizontal',
};

const CATEGORY_COLORS = {
  Groceries: '#00E5FF',
  Rent: '#7B2FBE',
  Transportation: '#06B6D4',
  Entertainment: '#8B5CF6',
  Shopping: '#EC4899',
  Dining: '#F59E0B',
  Healthcare: '#10B981',
  Other: '#6B7280',
};

function getProgressColor(pct) {
  if (pct >= 90) return '#EF4444';
  if (pct >= 70) return '#F59E0B';
  return '#10B981';
}

export default function CategorySlider({ category, allocated, spent, weeklyLimit, alertEnabled, rollover, onAllocatedChange, onWeeklyLimitChange, onAlertToggle, onRolloverToggle, onDelete, isCustom, totalBudget }) {
  const pct = allocated > 0 ? Math.min((spent / allocated) * 100, 100) : 0;
  const progressColor = getProgressColor(pct);
  const icon = CATEGORY_ICONS?.[category] || 'Tag';
  const color = CATEGORY_COLORS?.[category] || '#00E5FF';
  const maxAlloc = totalBudget || 10000;

  return (
    <div className="bg-[rgba(255,255,255,0.04)] border border-[rgba(0,229,255,0.1)] rounded-xl p-4 hover:border-[rgba(0,229,255,0.2)] transition-all duration-200">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}20` }}>
            <Icon name={icon} size={16} color={color} />
          </div>
          <span className="text-[#E2E8F0] font-medium text-sm">{category}</span>
        </div>
        <div className="flex items-center gap-2">
          {isCustom && (
            <button onClick={onDelete} className="text-[#64748B] hover:text-[#EF4444] transition-colors p-1 rounded">
              <Icon name="Trash2" size={14} />
            </button>
          )}
          <span className="text-xs font-mono" style={{ color: progressColor }}>
            ${spent?.toFixed(0) || 0} / ${allocated?.toFixed(0) || 0}
          </span>
        </div>
      </div>
      {/* Progress Bar */}
      <div className="w-full h-1.5 bg-[rgba(255,255,255,0.08)] rounded-full mb-3 overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${pct}%`, backgroundColor: progressColor }}
        />
      </div>
      {/* Allocation Slider */}
      <div className="mb-3">
        <div className="flex justify-between text-xs text-[#64748B] mb-1">
          <span>Allocated</span>
          <span className="text-[#00E5FF]">${allocated?.toFixed(0)}</span>
        </div>
        <input
          type="range"
          min={0}
          max={maxAlloc}
          step={10}
          value={allocated || 0}
          onChange={(e) => onAllocatedChange(Number(e?.target?.value))}
          className="w-full h-1.5 rounded-full appearance-none cursor-pointer"
          style={{ accentColor: color }}
        />
      </div>
      {/* Weekly Limit */}
      <div className="flex items-center gap-3 mb-2">
        <div className="flex-1">
          <label className="text-xs text-[#64748B] block mb-1">Weekly Limit</label>
          <input
            type="number"
            value={weeklyLimit || ''}
            onChange={(e) => onWeeklyLimitChange(Number(e?.target?.value))}
            placeholder="No limit"
            className="w-full bg-[rgba(255,255,255,0.06)] border border-[rgba(0,229,255,0.1)] rounded-lg px-2 py-1 text-xs text-[#E2E8F0] focus:outline-none focus:border-[#00E5FF] placeholder-[#475569]"
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs text-[#64748B]">Alert</label>
          <button
            onClick={onAlertToggle}
            className={`w-10 h-5 rounded-full transition-all duration-200 relative ${alertEnabled ? 'bg-[#00E5FF]' : 'bg-[rgba(255,255,255,0.1)]'}`}
          >
            <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white transition-all duration-200 ${alertEnabled ? 'left-5' : 'left-0.5'}`} />
          </button>
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs text-[#64748B]">Rollover</label>
          <button
            onClick={onRolloverToggle}
            className={`w-10 h-5 rounded-full transition-all duration-200 relative ${rollover ? 'bg-[#7B2FBE]' : 'bg-[rgba(255,255,255,0.1)]'}`}
          >
            <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white transition-all duration-200 ${rollover ? 'left-5' : 'left-0.5'}`} />
          </button>
        </div>
      </div>
    </div>
  );
}
